import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70278cf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#ffffff"} }
const _hoisted_2 = { class: "window" }
const _hoisted_3 = { class: "inquiry-right-div" }
const _hoisted_4 = { style: {"margin-left":"1%"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inquiry-header-remark" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-left":"15px","justify-content":"center","margin-top":"13px"} }, " If you have any questions while using SCAN system, please contact us at each e-mail address below corresponding to the function you would like to make inquiry. ")
], -1 /* HOISTED */))
const _hoisted_6 = { id: "inquiryDiv" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"calc(100% - 16px)"} }, [
  /*#__PURE__*/_createElementVNode("table", { id: "tblInquiryInfo" }, [
    /*#__PURE__*/_createElementVNode("thead", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", { width: "50%" }, "Function Name"),
        /*#__PURE__*/_createElementVNode("th", { width: "50%" }, "Addresses for Inquiry")
      ])
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_9 = {
  key: 1,
  id: "tblInquirydiv",
  style: {"overflow":"auto"}
}
const _hoisted_10 = { id: "tblInquiryInfo" }
const _hoisted_11 = { id: "tbltbodyinquiry" }
const _hoisted_12 = { width: "50%" }
const _hoisted_13 = { width: "50%" }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Navigation"]),
      _createVNode($setup["InquiryNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
      _createVNode($setup["InquiryLinkNavigation"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["Alert"], {
            alertMessage: $setup.alertMessage,
            alertState: $setup.alertState
          }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          ($setup.inquiryInfo.length === 0 && $setup.getData)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_8, " No data "))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("tbody", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.inquiryInfo, (info, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_12, _toDisplayString(info.functionName), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("a", {
                            href: 
                        'mailto:' +
                        info.address +
                        '?subject=' +
                        encodeURIComponent(info.functionName)
                      
                          }, _toDisplayString(info.address), 9 /* TEXT, PROPS */, _hoisted_14)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}